import ModalStyles from './ImagePickerModal.module.scss'
import { useImagePickerContext } from './ImagePickerContext'
import { ConfirmSelectionButton } from './ConfirmSelectionButton'
import { SelectionCount } from './SelectionCount'
import { useConfirm as useConfirmStock } from './Stock/useConfirm'
import { useConfirm as useConfirmLink } from './Link/useConfirm'
import { useConfirm as useConfirmAi } from './AIGeneration/useConfirm'

export const ConfirmButton = () => {
  const imagePickerContext = useImagePickerContext()
  const { provider, selectedImages, maxCount, onConfirm } = imagePickerContext

  const { confirm: confirmStock, isConfirming: isConfirmingStock } = useConfirmStock()
  const { confirm: confirmLink, isConfirming: isConfirmingLink } = useConfirmLink()
  const { confirm: confirmAi, isConfirming: isConfirmingAi } = useConfirmAi()

  return (
    <div className={ModalStyles.footerActions}>
      {provider !== 'ai' && maxCount > 1 && selectedImages.length > 0 && <SelectionCount />}
      {provider === 'ai' && (
        <ConfirmSelectionButton
          onPress={() => confirmAi()}
          isDisabled={isConfirmingAi || !selectedImages.length}
          confirmLabel="Confirm"
        />
      )}
      {(provider === 'stock' || selectedImages[0]?.unsplash) && (
        <>
          <ConfirmSelectionButton
            onPress={confirmStock}
            isDisabled={isConfirmingStock || !selectedImages.length}
            confirmLabel="Confirm"
          />
        </>
      )}
      {provider === 'link' && (
        <>
          <ConfirmSelectionButton
            onPress={confirmLink}
            isDisabled={isConfirmingLink || !selectedImages.length}
            confirmLabel="Confirm"
          />
        </>
      )}
      {(provider === 'uploads' || (!provider && !selectedImages[0]?.unsplash)) && (
        <>
          <ConfirmSelectionButton
            onPress={() => onConfirm(selectedImages, imagePickerContext)}
            isDisabled={!selectedImages.length}
            confirmLabel="Confirm"
          />
        </>
      )}
    </div>
  )
}
